module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAMAAADVRocKAAAASFBMVEUAAAD////////////////////////////////////////////////////////////////////////////////////////////neHiwAAAAGHRSTlMAJIPH3/+/exgEk/v3o5swb+PnQLOLDNfXkH58AAAA3klEQVR4Ae3PBZIDMRBDUQ8oDFrM/W+aC4wVkMP6xYZ+1SWllFKaquuHEVc2zuaLoluu1rDazPX8Gey2CtgBfmKHPVq0WRgLmCuMaNKsCqBN460BBAjwDkC5sgABPgQgbwsQ4C0BAkqwAQJScAECWjABAlowAQJaMAECWjABAlowAQJaMAECWjABAlowAQJaMAECWjABQkQfIGS0Af8+QICXAwIECFCpNgDTfVWB7zbAUAW2bYC+Cvw0AdZdqfbbAvgr9f4PPjBbFiX8usBqWXQ/2+/rgXG3LxOllFJKR2jONWHFEjaLAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/open-white-icon.png
// module id = 161
// module chunks = 0